import { Component } from './Component';
import { ApiService } from '../services/ApiService';

/**
 * Component for handling Delete action.
 */
export class Delete extends Component {
  /**
   * String of the dom element of the submit button.
   *
   * @type {string}
   */
  static btnSubmit = '#btnSubmit';

  /**
   * Render template.
   *
   * @param {object} opts - The options to render in the component.
   */
  render(opts) {
    super.render(opts);
    this.attachListener();

    const title = document.querySelector('#title');

    if (title !== null) {
      title.focus();
    }
  }

  /**
   * Attach listener for the actual component.
   */
  attachListener() {
    this.attachConfirmEvent();
  }

  /**
   * Attach Submit event.
   */
  attachConfirmEvent() {
    document.querySelector(Delete.btnSubmit).addEventListener('click', (event) => {
      event.preventDefault();
      const opt = {
        // slice(7) return the value of the login parameter value
        // the swagger verify that the url is correct
        url: `${ApiService.apiSchema.deleteSend.url}?login=${encodeURIComponent(document.location.search.slice(7))}`,
        method: ApiService.apiSchema.deleteSend.method,
        data: {},
      };
      return Component.makeRequest(opt);
    });
  }
}
